const ROUTE_PATHS = {
  EDIT_KEG: "/editKeg",
  EDIT_BEVERAGE: "/editBeverage",
  MENU_EDITOR: "/menuEditor",
  ON_TAP: "/onTap",
  ON_DECK: "/onDeck",
  USER_SETTINGS: "/userSettings",
  MANAGEMENT: "/management-menu",
  SYS_ADMIN: "/sysadmin"
};

const KEG_SIZES_TO_OZ = {
  Half: 1984,
  Sixth: 661,
  Quarter: 992,
  "50L": 1690,
  "30L": 1014,
  "25L": 845,
  "20L": 676,
  "19.5L": 661,
  "15L": 507,
  "13.2 Gal": 1690,
  "5 Gal": 640,
  "2.5 Gal": 320,
};

const demoOnTapData = [
  {
    tapNumber: 1,
    name: "Beautiful Trouble",
    style: "IPA",
    type: "Beer",
    abv: "6.8%",
    percentFull: "10%",
    ounces: 66.1,
    kegSize: "Sixth",
    producer: "Ninkasi",
    category: "Draft",
    datePutOn: "1/21/2025 1:22PM",
  },
  {
    tapNumber: 2,
    name: "Hibiscus Ginger Beer",
    style: "Golden Ale w/ Hibiscus & Ginger",
    type: "Beer",
    abv: "4.7%",
    percentFull: "100%",
    ounces: 1984,
    kegSize: "Half",
    producer: "Caldera",
    category: "Draft",
    datePutOn: "1/7/2025 3:21PM",
  },
  {
    tapNumber: 3,
    name: "Study Break",
    style: "Hard Seltzer",
    type: "Hard Seltzer",
    abv: "6.5%",
    percentFull: "99.2%",
    ounces: 1898.1,
    kegSize: "Half",
    producer: "Study Break",
    category: "Draft",
    datePutOn: "1/14/2025 12:46PM",
  },
  {
    tapNumber: 4,
    name: "Willamette Valley Brut",
    style: "Chardonnay",
    type: "Wine",
    abv: "12%",
    percentFull: "99.9%",
    ounces: 1972.5,
    kegSize: "Half",
    producer: "Sand Lily",
    category: "Draft",
    datePutOn: "1/14/2025 12:49PM",
  },
  {
    tapNumber: 5,
    name: "Brambleberry Burn",
    style: "Cider w/ Blackberry, Boysenberries, & Jalapeño",
    type: "Cider",
    abv: "5.6%",
    percentFull: "36%",
    ounces: 679,
    kegSize: "Half",
    producer: "Eaglemount",
    category: "Draft",
    datePutOn: "1/14/2025 12:46PM",
  },
  {
    tapNumber: 6,
    name: "Cherry Limeade",
    style: "Hard Kombucha",
    type: "Kombucha",
    abv: "7%",
    percentFull: "0%",
    ounces: 0,
    kegSize: "Half",
    producer: "Sand Lily",
    category: "Draft",
    datePutOn: "1/14/2025 12:49PM",
  },
  {
    tapNumber: 7,
    name: "Pacific Pale",
    style: "Pale Ale",
    type: "Beer",
    abv: "5.4%",
    percentFull: "45%",
    ounces: 892,
    kegSize: "Quarter",
    producer: "Breakside",
    category: "Draft",
    datePutOn: "1/15/2025 2:00PM",
  },
  {
    tapNumber: 8,
    name: "Tropical Storm",
    style: "Fruited Sour",
    type: "Beer",
    abv: "4.8%",
    percentFull: "80%",
    ounces: 1600,
    kegSize: "Half",
    producer: "De Garde",
    category: "Draft",
    datePutOn: "1/17/2025 4:15PM",
  },
  {
    tapNumber: 9,
    name: "Smoky Maple Stout",
    style: "Stout",
    type: "Beer",
    abv: "7.2%",
    percentFull: "55%",
    ounces: 990,
    kegSize: "Sixth",
    producer: "Barrelhouse",
    category: "Draft",
    datePutOn: "1/19/2025 5:42PM",
  },
  {
    tapNumber: 10,
    name: "Vanilla Bean Porter",
    style: "Porter",
    type: "Beer",
    abv: "5.9%",
    percentFull: "33%",
    ounces: 693,
    kegSize: "Sixth",
    producer: "Deschutes",
    category: "Draft",
    datePutOn: "1/20/2025 1:15PM",
  },
  {
    tapNumber: 11,
    name: "Applewood Cider",
    style: "Cider",
    type: "Cider",
    abv: "5.3%",
    percentFull: "70%",
    ounces: 1390,
    kegSize: "Half",
    producer: "Seattle Cider Co.",
    category: "Draft",
    datePutOn: "1/18/2025 11:05AM",
  },
  {
    tapNumber: 12,
    name: "Pineapple Express",
    style: "Hazy IPA",
    type: "Beer",
    abv: "6.9%",
    percentFull: "50%",
    ounces: 992,
    kegSize: "Quarter",
    producer: "Stone Brewing",
    category: "Draft",
    datePutOn: "1/16/2025 3:33PM",
  },
  {
    tapNumber: 13,
    name: "Rosé All Day",
    style: "Rosé",
    type: "Wine",
    abv: "11.5%",
    percentFull: "85%",
    ounces: 1685,
    kegSize: "Half",
    producer: "Summerland Winery",
    category: "Draft",
    datePutOn: "1/15/2025 2:55PM",
  },
  {
    tapNumber: 14,
    name: "Spiced Plum Cider",
    style: "Cider",
    type: "Cider",
    abv: "5.4%",
    percentFull: "40%",
    ounces: 799,
    kegSize: "Quarter",
    producer: "2 Towns Ciderhouse",
    category: "Draft",
    datePutOn: "1/17/2025 12:30PM",
  },
  {
    tapNumber: 15,
    name: "Midnight Espresso",
    style: "Coffee Stout",
    type: "Beer",
    abv: "8.0%",
    percentFull: "22%",
    ounces: 396,
    kegSize: "Sixth",
    producer: "Modern Times",
    category: "Draft",
    datePutOn: "1/12/2025 6:10PM",
  },
  {
    tapNumber: 16,
    name: "Lavender Lemonade",
    style: "Hard Kombucha",
    type: "Kombucha",
    abv: "6.5%",
    percentFull: "66%",
    ounces: 1298,
    kegSize: "Half",
    producer: "Boochcraft",
    category: "Draft",
    datePutOn: "1/13/2025 5:00PM",
  },
];

const demoOnDeckData = [
  {
    qty: 1,
    name: "Beautiful Trouble",
    style: "IPA",
    storedIn: "Cooler",
    type: "Beer",
    abv: "6.8%",
    percentFull: "10%",
    ounces: 66.1,
    kegSize: "Sixth",
    producer: "Ninkasi",
    category: "Draft",
    datePutOn: "1/21/2025 1:22PM",
  },
  {
    qty: 4,
    name: "Hibiscus Ginger Beer",
    style: "Golden Ale w/ Hibiscus & Ginger",
    storedIn: "Cooler",
    type: "Beer",
    abv: "4.7%",
    percentFull: "100%",
    ounces: 1984,
    kegSize: "Half",
    producer: "Caldera",
    category: "Draft",
    datePutOn: "1/7/2025 3:21PM",
  },
  {
    qty: 1,
    name: "Study Break",
    style: "Hard Seltzer",
    storedIn: "Cooler",
    type: "Hard Seltzer",
    abv: "6.5%",
    percentFull: "99.2%",
    ounces: 1898.1,
    kegSize: "Half",
    producer: "Study Break",
    category: "Draft",
    datePutOn: "1/14/2025 12:46PM",
  },
  {
    qty: 2,
    name: "Willamette Valley Brut",
    style: "Chardonnay",
    storedIn: "Cellar",
    type: "Wine",
    abv: "12%",
    percentFull: "99.9%",
    ounces: 1972.5,
    kegSize: "Half",
    producer: "Sand Lily",
    category: "Draft",
    datePutOn: "1/14/2025 12:49PM",
  },
  {
    qty: 1,
    name: "Brambleberry Burn",
    style: "Cider w/ Blackberry, Boysenberries, & Jalepeno",
    storedIn: "Cooler",
    type: "Cider",
    abv: "",
    percentFull: "36%",
    ounces: 679,
    kegSize: "Half",
    producer: "Eaglemount",
    category: "Draft",
    datePutOn: "1/14/2025 12:46PM",
  },
  {
    qty: 3,
    name: "Cherry Limeade",
    style: "Hard Kombucha",
    storedIn: "Cellar",
    type: "Kombucha",
    abv: "7%",
    percentFull: "0%",
    ounces: 0,
    kegSize: "Half",
    producer: "Sand Lily",
    category: "Draft",
    datePutOn: "1/14/2025 12:49PM",
  },
];


const constants = {
  ROUTE_PATHS,
  demoOnTapData,
  KEG_SIZES_TO_OZ,
  demoOnDeckData,
};

export default constants;
